import React, {useEffect, useState} from 'react';
import ScrollableTabs from "../../../../components/Common/ScrollableTabs";
import {OrderApi, OrderTrackingStatus} from "../../../../services/Api/types";
import {getRestOfPreparationStatuses} from "./utils/orderPreparationStatus";
import OrderPreparationStatus from "./OrderPreparationStatus";

interface Props {
    order: OrderApi;
    orderTrackingStatus: OrderTrackingStatus;
}

const OrderPreparationStatusStatuses = ({order, orderTrackingStatus}: Props) => {
    const [statuses, setStatuses] = useState<OrderTrackingStatus[]>(getRestOfPreparationStatuses(orderTrackingStatus));

    useEffect(() => {
        setStatuses(getRestOfPreparationStatuses(orderTrackingStatus))
    }, [orderTrackingStatus]);

    return (
        <div className="summary-order-preparation-status-statuses">
            <ScrollableTabs hideScrollbars={false} scrollStep={60}>
                {
                    statuses.map(status => (
                        <OrderPreparationStatus
                            key={status}
                            status={status}
                            order={order}
                            orderStatus={orderTrackingStatus}
                        />))
                }
            </ScrollableTabs>
        </div>
    )
}

export default OrderPreparationStatusStatuses;